module.exports = __webpack_public_path__ + "img/top_libraly.a99c39d5.jpg";